import React from "react";
import {Model, surveyLocalization} from "survey-core";
import {Survey} from "survey-react-ui";
import "survey-core/survey-core.css";
import {db} from "../../firebase";
import {addDoc, collection} from "firebase/firestore";

// Greek localization settings
surveyLocalization.locales["el"] = {
    pagePrevText: "Πίσω",
    pageNextText: "Επόμενο",
    completeText: "Ολοκλήρωση",
    requiredError: "Απαιτείται απάντηση.",
    emailError: "Παρακαλώ εισάγετε μια έγκυρη διεύθυνση e-mail."
};
surveyLocalization.defaultLocale = "el";

const SurveyOrganizationForm = () => {
    const surveyJson = {
        completedHtml: "<h3>Σας ευχαριστούμε που συμπληρώσατε την αίτηση.</h3>",
        title: "Υποβολή Αιτήματος για προσθήκη Οργάνωσης Ασθενών στον Ελληνικό Χάρτη Σπανίων Παθήσεων (Rare Diseases Greece Map)",
        description: "Ο Ελληνικός Χάρτης Σπανίων Παθήσεων είναι ένα δυναμικό εργαλείο στο οποίο προστίθενται συνεχώς όσες πληροφορίες είναι διαθέσιμες για τις Οργανώσεις Ασθενών που έχει καταγράψει η Ένωση Σπανίων Ασθενών Ελλάδος στην Ελλάδα. Παρακαλούμε συμπληρώστε την παρακάτω φόρμα.",
        pages: [{
            name: "organization", title: "Στοιχεία Οργάνωσης", elements: [{
                type: "text", name: "Ελληνική Επωνυμία", title: "Ελληνική Επωνυμία:", isRequired: true
            }, {
                type: "text", name: "Αγγλική Επωνυμία", title: "Αγγλική Επωνυμία:", isRequired: true
            }, {
                type: "dropdown",
                name: "Τύπος Οργάνωσης",
                title: "Τύπος Οργάνωσης:",
                isRequired: true,
                choices: ["Σύλλογος Ασθενών", "ΑμκΕ", "Εταιρεία", "Μ.Κ.Ο."]
            }, {
                type: "text", name: "Διεύθυνση Έδρας", title: "Διεύθυνση Έδρας Οργάνωσης:", isRequired: true
            }, {
                type: "text",
                name: "Διεύθυνση Αλληλογραφίας",
                title: "Διεύθυνση Αλληλογραφίας (σε περίπτωση που διαφέρει από την έδρα):"
            }, {
                type: "text", name: "Τηλέφωνο Επικοινωνίας", title: "Τηλέφωνο Υπεύθυνου Επικοινωνίας:", isRequired: true
            }, {
                type: "text", name: "Email Οργάνωσης", title: "Email:", inputType: "email", isRequired: true
            }, {
                type: "text", name: "Website Οργάνωσης", title: "Website:"
            }]
        }, {
            name: "diseases", title: "Σπάνιες Παθήσεις", elements: [{
                type: "matrixdynamic",
                name: "πάθειες",
                title: "Παρακαλούμε σημειώστε όποια στοιχεία γνωρίζετε για τις Σπάνιες Παθήσεις που έχει καταγράψει η Οργάνωσή σας, από τις οποίες πάσχει τουλάχιστον ένας ζώντας ασθενής που είναι μέλος σας:",
                description: "Είναι σημαντικό να συμπληρωθούν όσο το δυνατόν περισσότερα στοιχεία",
                addRowText: "Προσθήκη Πάθησης",
                removeRowText: "Αφαίρεση",
                rowCount: 1,
                columns: [{
                    name: "Ελληνικό Όνομα Πάθησης", title: "Ελληνικό Όνομα Πάθησης", cellType: "text"
                }, {
                    name: "Αγγλικό Όνομα Πάθησης", title: "Αγγλικό Όνομα Πάθησης", cellType: "text", isRequired: true
                }, {
                    name: "Συντομογραφία Πάθησης", title: "Συντομογραφία Πάθησης", cellType: "text"
                }, {
                    name: "ORPHACODE", title: "ORPHACODE", cellType: "text"
                }, {
                    name: "Κέντρο", title: "Κέντρο Εμπειρογνωμοσύνης / Ειδική Μονάδα / Ειδικό Ιατρείο", cellType: "text"
                }]
            }]
        }, {
            name: "applicant", title: "Στοιχεία Αιτούντος", elements: [{
                type: "text",
                name: "Ονοματεπώνυμο Αίτησης",
                title: "Ονοματεπώνυμο Ατόμου που πραγματοποιεί την αίτηση:",
                isRequired: true
            }, {
                type: "text",
                name: "Email Αίτησης",
                title: "Email Ατόμου που πραγματοποιεί την αίτηση:",
                inputType: "email",
                isRequired: true
            }, {
                type: "html", name: "declaration", html: `<p>
              Η Ένωση Σπανίων Ασθενών Ελλάδος (Ε.Σ.Α.Ε) συλλέγει και επεξεργάζεται τα προσωπικά σας δεδομένα αποκλειστικά για σκοπούς επικοινωνίας με την Ε.Σ.Α.Ε. Η επεξεργασία των δεδομένων σας διέπεται από τον Γενικό Κανονισμό για την Προστασία Δεδομένων (ΕΕ) 2016/679 (GDPR) και τον Νόμο 4624/2019 (ΦΕΚ Α' 137/29.08.2019). Ο οργανισμός έχει λάβει τα απαραίτητα μέτρα ώστε τα δεδομένα σας να αποθηκεύονται με ασφάλεια και προστατεύονται από μη εξουσιοδοτημένη πρόσβαση. Δεν κοινοποιούμε τα δεδομένα σας σε τρίτους χωρίς τη συγκατάθεσή σας, εκτός αν απαιτείται από τον νόμο. Σύμφωνα με τον GDPR, έχετε τα εξής δικαιώματα: Πρόσβαση, Διόρθωση, Διαγραφή (εφόσον δεν υπάρχει άλλη νομική βάση για τη διατήρησή τους), περιορισμό επεξεργασίας καθώς και εναντίωση στην επεξεργασία. Για να ασκήσετε τα δικαιώματά σας ή για περισσότερες πληροφορίες σχετικά με την επεξεργασία των δεδομένων σας, παρακαλούμε επικοινωνήστε μαζί μας στο info@rarediseasesgreece.gr ή ανατρέξτε στην πολιτική απορρήτου μας [<< Link >>].
              Με την υποβολή αυτής της φόρμας, δηλώνετε ότι έχετε διαβάσει και κατανοήσει την παραπάνω ενημέρωση σχετικά με την επεξεργασία των προσωπικών σας δεδομένων.
            </p>`
            }]
        }]
    };

    const survey = new Model(surveyJson);

    // Save survey response to Firestore upon completion
    survey.onComplete.add(async (sender) => {
        const surveyData = sender.data;
        try {
            await addDoc(collection(db, "addOrganizationForm"), surveyData);
            console.log("Survey response saved to Firestore:", surveyData);
        } catch (error) {
            console.error("Error saving survey response to Firestore:", error);
        }
    });

    return (<div className="survey-container">
        <Survey model={survey}/>
        <footer style={{textAlign: "center", fontSize: "x-large", color: "#555"}}>
            Καπνικαρέας 19Α | Αθήνα | 10556 | T. 694 344 8509 | E. info@rarediseasesgreece.gr
        </footer>
    </div>);
};

export default SurveyOrganizationForm;
